export enum PagesEnum {
  HOME = 'home',
  ENGAGE = 'engage',
  FIND = 'find',
  FRIENDS = 'friends',
  AIRDROP = 'airdrop',
}
